import state from "./moduleTokenState";
import mutations from "./moduleTokenMutations";
import actions from "./moduleTokenActions";
import getters from "./moduleTokenGetters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
